import { Project } from '@qality/common-model';
import {
  StorageOfUniqueServices,
  AxiosWrapperService as axios,
} from '@qality/common-service';

import API from './API';
import AuthenticateService from './AuthenticateService';

type GetProjectsPaginatedParams = {
  filterByQAlitySettings?: boolean;
};

export default {
  //TODO: ATESTM-190
  /**
   * fetch ALL non-private (browse permission) projects
   * @param {*} params
   * @param {boolean} filterByQAlitySettings whether to filter availability settings
   * @returns {Array} list of projects
   */
  async getProjectsPaginated({
    filterByQAlitySettings,
  }: GetProjectsPaginatedParams = {}): Promise<unknown> {
    let url = StorageOfUniqueServices.get('APIConstants').URL_ENABLED_PROJECTS;
    if (filterByQAlitySettings) {
      url = `${url}?filterByQAlitySettings=true`;
    }
    const projectsResponse = await API.request(url);
    return JSON.parse(projectsResponse.body);
  },

  async isQAlityConfiguredInAnyProject(): Promise<boolean> {
    const origin = StorageOfUniqueServices.get('WindowOriginService').origin;
    const apiPath =
      StorageOfUniqueServices.get('APIConstants').URL_QALITY_CONFIGURED;
    const url = await AuthenticateService.authenticateByJWT(origin + apiPath);
    const response = await axios.get(url);
    return response.data;
  },

  async getAnyProjectWithConfiguredQAlity(): Promise<Project> {
    const origin = StorageOfUniqueServices.get('WindowOriginService').origin;
    const apiPath =
      StorageOfUniqueServices.get('APIConstants').URL_QALITY_CONFIGURED_PROJECT;
    const url = await AuthenticateService.authenticateByJWT(origin + apiPath);
    const response = await axios.get(url);
    return new Project(response.data);
  },
};
